import { Button } from 'reactstrap'

const TransactionLogAction = ({ onClick, gridRelatedData }) => {
  let refundList = gridRelatedData?.gridData?.data?.filter((item) => item.status?.toLowerCase() === 'waiting for approval')
  let confirmPayment = gridRelatedData?.gridData?.data?.filter((item) => item.status?.toLowerCase() === 'confirm')
  let isButtonDisabled = false
  if (refundList?.length > 0) {
    isButtonDisabled = true
  }else if(confirmPayment?.length === 0) {
    isButtonDisabled = true
  }

  return (
    <>
      <Button
        className='bg-warning px-2 rounded cursor-pointer text-white'
        disabled={isButtonDisabled}
        style={{ border: 'none', paddingTop: '0.3rem', paddingBottom: '0.3rem' }}
        onClick={() => {
          onClick()
        }}>
        Refund Request
      </Button>
    </>
  )
}

export default TransactionLogAction
